<form autocomplete="off" class="theme-form" ngNativeValidate #AMLDetailsForm="ngForm">
<div class="offcanvas-header d-flex align-items-center justify-content-between position-relative">
  <div class="d-flex align-items-center justify-content-start font-semibold text-primary f-16">AML Details</div>
  <div class="d-flex align-items-center justify-content-end border-bottom gap-2">
    <app-button class="my-0" (buttonOutputEvent)="Clear()" [buttonLabel]="'Clear'" [buttonClass]="'light_button'"
      [buttonType]="'button'">
    </app-button>
    <app-button class="m-0" (buttonOutputEvent)="Save()" [buttonLabel]="'Save'" [buttonClass]="'blue_button'"
      [buttonType]="'submit'">
    </app-button>
    <app-button class="my-0" (buttonOutputEvent)="Close()" [buttonLabel]="'Close'" [buttonClass]="'light_button'"
      [buttonType]="'button'">
    </app-button>
  </div>
</div>
  <div class="modal-body p-3">
    <div class="px-2">
      <div class="w-100 border-bottom row mb-2">
      <div class="col-6 d-flex align-items-center  pe-2 px-0 mb-2">
        <label class="w-150px  f-14 font-semibold text-gray-color mb-0" for="occupation">Occupation<span
            class="text-color-danger">*</span></label>
        <div class="col">
          <app-select 
            [id]="'occupation'" 
            [name]="'occupation'" 
            [options]="OccupationDropdown"
            [selectedValue]="amlDetailsModel?.occupation" 
            (valueChanged)="amlDetailsModel.occupation = $event"
            [isRequired]="true" 
            (keydown.enter)="onKeydown($event, 'sourceOfIncome')"
            >
          </app-select>
        </div>
      </div>
      <div class="col-6 d-flex align-items-center  pe-2 px-0 mb-2">
        <label class="w-150px  f-14 font-semibold text-gray-color mb-0" for="sourceOfIncome">Source Of Income<span
            class="text-color-danger">*</span></label>
        <div class="col">
          <app-select 
            [id]="'sourceOfIncome'" 
            [name]="'sourceOfIncome'" 
            [options]="sourceOfIncomeDropdown"
            [selectedValue]="amlDetailsModel?.sourceOfIncome" 
            (valueChanged)="amlDetailsModel.sourceOfIncome = $event"
            [isRequired]="true" 
            (keydown.enter)="onKeydown($event, 'purpose')">
          </app-select>
        </div>
      </div>
      <div class="col-6 d-flex align-items-center  pe-2 px-0 mb-2">
        <label class="w-150px  f-14 font-semibold text-gray-color mb-0" for="purpose">Purpose<span
            class="text-color-danger">*</span></label>
        <div class="col">
          <app-select 
            [id]="'purpose'" 
            [name]="'purpose'" 
            [options]="purposeDropdown" 
            [selectedValue]="amlDetailsModel?.purpose"
            (valueChanged)="amlDetailsModel.purpose = $event" 
            [isRequired]="true"
            (keydown.enter)="onKeydown($event, 'paymentMode')"
            >
          </app-select>
        </div>
      </div>
      <div class="col-6 d-flex align-items-center  pe-2 px-0 mb-2">
        <label class="w-150px  f-14 font-semibold text-gray-color mb-0" for="paymentMode">Payment Mode<span
            class="text-color-danger">*</span></label>
        <div class="col">
          <app-select 
            [id]="'paymentMode'" 
            [name]="'paymentMode'" 
            [options]="paymentModeDropdown"
            [selectedValue]="amlDetailsModel?.paymentMode" 
            (valueChanged)="amlDetailsModel.paymentMode = $event"
            [isRequired]="true" 
            (keydown.enter)="onKeydown($event, 'idType')"
            >
          </app-select>
        </div>
      </div>
      <div class="col-6 d-flex align-items-center  pe-2 px-0 mb-2">
        <label class="w-150px  f-14 font-semibold text-gray-color mb-0" for="idType">Id Type<span
            class="text-color-danger">*</span></label>
        <div class="col">
          <app-select 
            [id]="'idType'" 
            [name]="'idType'" 
            [options]="idIssuedByDropdown" 
            [selectedValue]="amlDetailsModel?.idType"
            (valueChanged)="amlDetailsModel.idType = $event" 
            [isRequired]="true"
            (keydown.enter)="onKeydown($event, 'idIssuedBy')"
            >
          </app-select>
        </div>
      </div>
      <div class="col-6 d-flex align-items-center  pe-2 px-0 mb-2">
        <label class="w-150px  f-14 font-semibold text-gray-color mb-0" for="idIssuedBy">Id Issued By<span
            class="text-color-danger">*</span></label>
        <div class="col">
          <app-input 
            [inputName]="'idIssuedBy'" 
            [inputType]="'text'" 
            [inputId]="'idIssuedBy'"
            [inputValue]="amlDetailsModel?.idIssuedBy" 
            (inputValueEmit)="amlDetailsModel.idIssuedBy = $event"
            [isRequired]="true" 
            (keydown.enter)="onKeydown($event, 'idIssuedDate')" 
            [enableFocus]="true"
            >
          </app-input>
        </div>
      </div>
      <div class="col-6 d-flex align-items-center pe-2 px-0 mb-2">
        <div class="w-150px f-14 font-semibold text-gray-color text-nowrap mb-0">
          Id Issued Date<span
          class="text-color-danger">*</span>
        </div>
        <div class="col">
          <app-input-datepicker-renderer
          #idIssuedDateComp 
            [id]="'idIssuedDate'" 
            [inputDatepickerName]="'idIssuedDate'"
            [inputDate]="amlDetailsModel?.idIssuedDate"                
            (dateChanged)="amlDetailsModel.idIssuedDate= $event"          
            (keydown)="onKeydown($event,'idExpiryDate')"
            ></app-input-datepicker-renderer>
        </div>
      </div>
      <div class="col-6 d-flex align-items-center pe-2 px-0 mb-2">
        <div class="w-150px f-14 font-semibold text-gray-color text-nowrap mb-0">
          Id Expiry Date<span
          class="text-color-danger">*</span>
        </div>
        <div class="col">
          <app-input-datepicker-renderer
          #idExpiryDateComp 
            [id]="'idExpiryDate'" 
            [inputDatepickerName]="'idExpiryDate'"
            [inputDate]="amlDetailsModel?.idExpiryDate"
            (dateChanged)="amlDetailsModel.idExpiryDate =$event"
            (keydown)="onKeydown($event,'gender')"
           >
          </app-input-datepicker-renderer>
        </div>
      </div>
      <div class="col-6 d-flex align-items-center  pe-2 px-0 mb-2">
        <label class="w-150px  f-14 font-semibold text-gray-color mb-0" for="gender">Gender<span
            class="text-color-danger">*</span></label>
        <div class="col">
          <app-select 
            [id]="'gender'" 
            [name]="'gender'" 
            [options]="genderDropdown" 
            [selectedValue]="amlDetailsModel?.gender"
            (valueChanged)="amlDetailsModel.gender = $event" 
            [isRequired]="true"
            (keydown.enter)="onKeydown($event, 'modeofApproach')"
            >
          </app-select>
        </div>
      </div>
      <div class="col-6 d-flex align-items-center  pe-2 px-0 mb-2">
        <label class="w-150px  f-14 font-semibold text-gray-color mb-0" for="modeOfApproach">Mode of Approach<span
            class="text-color-danger">*</span></label>
        <div class="col">
          <app-select 
            [id]="'modeOfApproach'" 
            [name]="'modeOfApproach'" 
            [options]="modeofApproachDropdown"
            [selectedValue]="amlDetailsModel?.modeOfApproach" 
            (valueChanged)="amlDetailsModel.modeOfApproach = $event"
            [isRequired]="true" 
            >
          </app-select>
        </div>
      </div>
      <div class="col-6 d-flex align-items-center  pe-2 px-0 mb-2">
        <label class="w-150px f-14 font-semibold text-gray-color mb-0" for="productType">Product Type<span
            class="text-color-danger">*</span></label>
        <div class="col">
          <app-select 
            [id]="'productType'" 
            [name]="'productType'" 
            [options]="productTypeDropdown"
            [selectedValue]="amlDetailsModel?.productType" 
            (valueChanged)="amlDetailsModel.productType = $event"
            [isRequired]="true"
            >
          </app-select>
        </div>
      </div>
    </div>
        <div class="col-3 pe-2 px-0 mb-2 d-flex w-100">
          <label class="f-14 font-semibold text-gray-color mb-0 w-30" for="pep">
            Politically Exposed Person (PEP)?<span class="text-color-danger">*</span>
          </label>
          <div class="col">
            <div class="d-flex gap-1">
              <div class="col-2 d-flex align-items-center gap-2">
                <input class="radio_Button" type="radio" id="pepYes" name="pep" [value]="pep.Yes" [(ngModel)]="amlDetailsModel.pep"/>
                <label for="pepYes" class="f-14 mb-0 text-gray-color font-regular cursorPointer">Yes</label>
              </div>
              <div class="col d-flex align-items-center gap-2">
                <input class="radio_Button" type="radio" id="pepNo" name="pep" [value]="pep.No" [(ngModel)]="amlDetailsModel.pep" />
                <label for="pepNo" class="f-14 mb-0 text-gray-color font-regular cursorPointer">No</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3 pe-2 px-0 mb-2 d-flex w-100">
          <label class="f-14 font-semibold text-gray-color mb-0 w-30" for="dualNationality">
            Do you have Dual Nationality?<span class="text-color-danger">*</span>
          </label>
          <div class="col">
            <div class="d-flex gap-1">
              <div class="col-2 d-flex align-items-center gap-2">
                <input class="radio_Button" type="radio" id="dualYes" name="dualNationality" [value]="dualNationality.Yes" [(ngModel)]="amlDetailsModel.dualNationality"/>
                <label for="dualYes" class="f-14 mb-0 text-gray-color font-regular cursorPointer">Yes</label>
              </div>
              <div class="col d-flex align-items-center gap-2">
                <input class="radio_Button" type="radio" id="dualNo" name="dualNationality" [value]="dualNationality.No" [(ngModel)]="amlDetailsModel.dualNationality" />
                <label for="dualNo" class="f-14 mb-0 text-gray-color font-regular cursorPointer">No</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3 pe-2 px-0 mb-2 d-flex w-100">
          <label class="f-14 font-semibold text-gray-color mb-0 w-30" for="residentialStatus">
            Residential Status<span class="text-color-danger">*</span>
          </label>
          <div class="col">
            <div class="d-flex">
              <div class="col-2 d-flex align-items-center gap-2">
                <input class="radio_Button" type="radio" id="resident" name="residentialStatus" [value]="residentialStatus.Resident" [(ngModel)]="amlDetailsModel.residentialStatus"/>
                <label for="resident" class="f-14 mb-0 text-gray-color font-regular cursorPointer">Resident</label>
              </div>
              <div class="col d-flex align-items-center gap-2 ms-1">
                <input class="radio_Button" type="radio" id="nonResident" name="residentialStatus" [value]="residentialStatus.NonResident" [(ngModel)]="amlDetailsModel.residentialStatus" />
                <label for="nonResident" class="f-14 mb-0 text-gray-color font-regular cursorPointer">Non-Resident</label>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</form>